<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button @click="applyFun" v-auth="`ORDER`" status="primary">下单</vxe-button>
        <vxe-button v-auth="`EXPORT`" @click="deriveFun">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showdiv">
            <a-input v-model="queryCondition.applyOrderCode" placeholder="订单号" clearable style="width: 160px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
            <a-select v-model="queryCondition.orderStatus" placeholder="订单状态" clearable style="width: 100px; margin-right: 1rem">
              <a-select-option
                v-for="item in selectLists.PromotionOrderStatus"
                :key="item.code"
                :value="item.code"
              >{{ item.value }}</a-select-option>
            </a-select>
          </div>
          <div>
            <vxe-button v-if="!showdiv" status="primary" @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-if="!showdiv" class="filter-search-item" @click="resetForm">重置</vxe-button>
            <vxe-button @click="cb">
              {{ showdiv ? '收起' : '更多选项' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--筛选拓展-->
      <div style="margin-top: 10px">
        <a-collapse>
          <div v-if="showdiv">
            <div v-if="showdiv">
              <SiftMaterialRequisition :data.sync="queryCondition" :list="selectLists" />
              <br>
              <div slot="footer" style="text-align: center; padding-bottom: 10px">
                <vxe-button @click="resetForm">重置</vxe-button>
                <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
              </div>
            </div>
          </div>
        </a-collapse>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        :loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
        @sort-change="listSortMethod"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <!-- <vxe-column field="regionName" title="大区" width="150" />
        <vxe-column field="dealerName" title="经销商全称" width="150" /> -->
        <vxe-column field="applyOrderCode" title="订单编号" width="130" />
        <vxe-column field="orgName" title="申领部门" width="130" />
        <vxe-column field="applyMan" title="申领人" width="130" />
        <vxe-column field="receiverName" title="收货人" width="130" />
        <vxe-column field="receivePhone" title="收货人联系方式" width="130" />
        <vxe-column field="applyTime" title="申领日期" width="130"  />
        <vxe-column field="orderMaterialCount" title="订单总项数" width="100" />
        <vxe-column field="orderNums" title="申领总数量" width="100" />
        <vxe-column field="orderTotalSums" title="申领总金额" width="100" />
        <vxe-column field="approveCommitDate" title="审批通过日期" width="130" />
        <vxe-column field="approveNums" title="审批总数量" width="100" />"
        <vxe-column field="approveTotalSums" title="审批总金额" width="100" />
        <vxe-column field="receiveTime" title="签收时间" width="130" />
        <vxe-column field="orderStatus" title="订单状态" width="150">
          <template #default="{ row }">
            <span v-if="row.orderStatus === '0'">录入中</span>
            <span v-else-if="row.orderStatus === '1'">审核中</span>
            <span v-else-if="row.orderStatus === '2'">审核通过</span>
            <span v-else-if="row.orderStatus === '3'">已驳回</span>
            <span v-else-if="row.orderStatus === '4'">部分收货</span>
            <span v-else-if="row.orderStatus === '5'">已收货</span>
            <span v-else-if="row.orderStatus === '6'">不通过</span>
          </template>
        </vxe-column>
        <!-- <vxe-column field="saveTime" title="首次保存日期" width="150" sortable />
        <vxe-column field="commitDate" title="提交日期" width="120" sortable /> -->
        <vxe-column title="操作" width="160" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operate">
              <a-button size="small" type="link" v-if="row.orderStatus === '0' || row.orderStatus === '3'" status="primary" v-auth="`UPDATE`" @click="editFun(row)">修改</a-button>
              <a-button size="small"  type="link" status="primary" v-auth="`VIEW`" @click="inspectFun(row)">查看</a-button>
              <!-- <a-button v-if="row.orderStatus === '1'" v-permission="['ApplyOrder:approve']" status="primary" @click="approveFun(row)">审核</a-button> -->
              <a-button size="small" type="link" v-if="row.orderStatus === '1'" status="primary" v-auth="`PROCESS`" @click="approveFun(row)">审核</a-button>
              <a-button size="small" type="link" v-if="(row.orderStatus === '2' || row.orderStatus === '4') && user.userNo == row.createUser" status="primary" v-auth="`RECEIVE`" @click="receiveFun(row)">收货</a-button>
              <a-button size="small" type="link" v-if="row.orderStatus === '0' || row.orderStatus === '3'" status="primary" v-auth="`DELETE`" @click="deleteFun(row)">删除</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!--导出对话框 -->
    <a-modal title="选择导出项" v-model="dialogVisible" width="400px">
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button size="small" @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button size="small" status="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
      </span>
    </a-modal>
    <ReceiveMaterialDialog :visible.sync="receiveDialog" :order.sync="rowOrder" :materialtable.sync="materialList" :OrderLogistics.sync="OrderLogisticsList" @receiveSubmit="receiveSubmit" />
  </div>
</template>

<script>
import SiftMaterialRequisition from './components/SiftMaterialRequisition.vue'
import ReceiveMaterialDialog from './components/ReceiveMaterialDialog.vue'
import {
  findOrderList,
  deleteApplyOrder,
  findOrderDetailList,
  receiveMaterial,
  exportOrder,
  getOrderById,
  findMaterialOrderLogisticsList,
  findAddressListAll,
} from '@/api/material'
import { outExcel } from '@/utils/Excel/outExcel'
import { mapGetters } from "vuex";
// import permission from '@/directive/permission/index.js' // 权限判断指令

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  // 广宣物料管理/广宣物料申领,
  name: 'AdvertiseMaterialRequisition',
  components: {
    SiftMaterialRequisition,
    ReceiveMaterialDialog
  },
  // directives: { permission },
  data() {
    return {
      showdiv: false,
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      base: {},
      tableData: [{}],
      allAlign: 'center',
      queryCondition: {},
      selectLists: {},
      // 导出对话框
      dialogVisible: false,
      disabled: true, // 已选择按钮是否禁用
      outExcelButtonLocading: false,
      ExportItem: 0,
      receiveDialog: false,
      rowOrder: {},
      materialList: [],
      OrderLogisticsList: [],
      sort: 'saveTime desc',
    }
  },
  computed: {
    // ...mapState("account", {currUser: "user"}),
    ...mapGetters('account', ['user']),
  },

  watch: {},
  created() {
    this.findAddressListAll()
    // 获取表格数据
    this.queryByPage()
    // 获取下拉框列表
    this.SelectListFun()
    
  },
  activated() {
    // 获取表格数据
    this.queryByPage()
    // 获取下拉框列表
    this.SelectListFun()
  },
  mounted() {},
  methods: {
// 转换单个收货人ID为姓名
    convertReceiverIdToName(receiverId) {
      if (!receiverId) return '';

      // 先尝试从地址簿查找
      if (this.receiveAddressList && this.receiveAddressList.length) {
        const address = this.receiveAddressList.find(item =>
            item.id && item.id.toString() === receiverId.toString()
        );
        if (address && address.recipientName) {
          return address.recipientName;
        }
      }
      return receiverId; // 如果找不到，返回原始ID
    },

    ensureReceiverName() {
      if (!this.order) return
      const rKey = this.order._receiverKey
      // const rKey = this.order.receiveId || this.order.receiver || this.order._receiverKey

      if (!rKey) return
      // 1) 后端直接给的姓名（标准字段）
      if (this.order.receiverName) return

      // 2) 地址簿映射
      if (Array.isArray(this.receiveAddressList) && this.receiveAddressList.length) {
        const hit = this.receiveAddressList.find(it => String(it.id) === String(rKey))
        if (hit && hit.recipientName) {
          this.receiverName = hit.recipientName
          return
        }
      }
    },

    async findAddressListAll() {
      const params = {
      }
      await findAddressListAll(params).then(res => {
        this.receiveAddressList = Array.isArray(res.data) ? res.data : []
        // 地址簿到位后立即尝试映射姓名
        this.ensureReceiverName()
      })
    },

    deriveFun() {
      this.dialogVisible = true
      // 判断是否选中
      this.disabled = this.$refs.xTable.selection.length < 1
    },
    // 导出表格
    async exportXlsxFun() {
      // 需要导出的数据
      let data = []
      const orderStatus = new Map([
        ['0', '录入中'],
        ['1', '审核中'],
        ['2', '审核通过'],
        ['3', '已驳回'],
        ['4', '部分收货'],
        ['5', '已收货'],
        ['6', '不通过']
      ])
      this.outExcelButtonLocading = true
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        let data = { page: 1, limit: this.pagination.total, sort: this.sort, ...this.queryCondition }
        exportOrder(data).then(val => {
          this.$exportExcelData(val, `物料申领订单表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          // 关闭弹窗
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
        return
      } else if (this.ExportItem == 1) {
        data = this.tableData
      } else if (this.ExportItem == 2) {
        data = this.$refs.xTable.selection
      }
      let table = []
      for (var i = 0; i < data.length; i++) {
        var params = {
          // 大区: data[i].obj,
          // 经销商全称: data[i].dealerName,
          申请部门: data[i].orgName,
          订单编号: data[i].applyOrderCode,
          申领人: data[i].createUser,
          // 订单状态: data[i].orderStatus,
          订单状态: orderStatus.get(data[i].orderStatus),
          订单总项数: data[i].orderMaterialCount,
          订单总数量: data[i].orderNums,
          订单总金额: data[i].orderTotalSums,
          首次保存日期: data[i].saveTime,
          提交日期: data[i].commitDate,
          审批通过日期: data[i].approveCommitDate,
          已收货数量: data[i].receiveNums,
          收货确认人: data[i].receiveMan,
          收货日期: data[i].receiveTime,
          审批人: data[i].approver,
          审批日期: data[i].approvedDate,
          审批意见: data[i].approveInfo,
          领料人: data[i].applyMan
        }
        table[i] = params
      }
      const wch = [15, 15, 15, 15, 15, 15, 15, 20, 20, 20, 15, 15, 20, 15, 20, 15, 15]
      outExcel('物料申领订单表', table, wch)
      // 关闭弹窗
      this.dialogVisible = false
      this.outExcelButtonLocading = false
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {}
      this.queryByPage(1)
    },
    listSortMethod({ sortList }) {
      console.log(sortList,'---sortList----');
      
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].property + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
    // 搜索表格数据
    async queryByPage(e) {
      if (e) this.pagination.current = e
      this.listLoading = true // 开启加载动画
      // 筛选条件
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        sort: this.sort,
        ...this.queryCondition
      }
      findOrderList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list

          // 直接转换收货人姓名，只使用地址簿映射
          this.tableData = this.tableData.map(item => ({
            ...item,
            receiverName: this.convertReceiverIdToName(item.receiver)
          }));

          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error('搜索失败')
        }
      })
    },
    cb() {
      this.showdiv = !this.showdiv
    },
    // 查看
    inspectFun(row) {
      this.$router.push({ path: `applyOrderDetail/${row.id}` , query: { orderStatus: row.orderStatus, applyOrderId: row.applyOrderId }})
    },
    // 下单
    applyFun() {
      this.$router.push({ path: 'applyOrder/null' })
    },
    // 修改
    editFun(row) {
      this.$router.push({ path: `applyOrder/${row.id}`, query: { orderStatus: row.orderStatus } })
    },
    // 删除
    deleteFun(row) {
      const data = { id: row.id }
      this.$confirm({
        title: '提示',
        content: '确定删除该订单？',
        onOk:() =>{
          deleteApplyOrder(data).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.queryByPage(1)
          } else {
            this.$message.error(res.message)
          }
        })
        },
        onCancel() {},
      });
    },
    // 审核
    approveFun(row) {
      this.$router.push({ path: `applyOrderApprove/${row.id}` })
    },
    // 收货
    receiveFun(row) {
      this.getOrderById(row.id)
      this.getMaterial(row.id)
      this.getOrderLogisticsList(row.id)
      this.receiveDialog = true
    },

    receiveSubmit(selection) {
      if (selection.length !== 0) {
        this.receiveDialog = false
        console.log(selection.data,"selection")
        // receiveMaterial(selection.data).then(res => {
          receiveMaterial(selection.data).then(res => {
            console.log(selection.data,"selection")
          if (res.code === 1) {
            this.$message.success('成功')
            this.queryByPage(1)
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.$message.error('请选择收货物料')
      }
    },
    getOrderById(id) {
      getOrderById(id).then(res => {
        if (res.code === 1) {
          const userInfo = this.$store.getters['account/user']
          this.rowOrder = res.data
          this.rowOrder.receiveMan = userInfo.userName
          this.rowOrder.receiveTime = new Date().toLocaleDateString().split('/').join('-')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getMaterial(id) {
      const data = {
        orderId: id,
        isReceive: 0 }
      findOrderDetailList(data).then(res => {
        if (res.code === 1) {
          this.materialList = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getOrderLogisticsList(id) {
        findMaterialOrderLogisticsList(id).then(res => {
        if (res.code === 1) {
          // this.OrderLogisticsList = res.data.list
          this.OrderLogisticsList = res.data
          console.log(this.OrderLogisticsList,'---1111----');
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 下拉框列表
    SelectListFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PromotionOrderStatus']).then(v => {
        this.selectLists = v
      })
    }
  }
}
</script>
<style lang="less" scoped>
.a-input--medium .a-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.a-button {
  font-size: 12px;
}
/deep/ .ant-collapse {
  border: none;
  background-color: #fff;
}
</style>
